// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CiscoIntegrationNewLeafIvrFillStatusResponse {
    'statusId': number;
    'ndc': string;
    'trackingNumber': string;
    'carrier': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CiscoIntegrationNewLeafIvrFillStatusResponse>> = [
        {
            "name":     "statusId",
            "baseName": "statusId",
            "type":     "number"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "trackingNumber",
            "baseName": "trackingNumber",
            "type":     "string"
        },
        {
            "name":     "carrier",
            "baseName": "carrier",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CiscoIntegrationNewLeafIvrFillStatusResponse.attributeTypeMap;
    }
}
